import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BackButton = styled.button`
  display: inline-flex;
  gap: 6px;
  align-items: center;
  align-self: flex-start;
  min-height: 32px;
  padding: 0;
  font: inherit;
  font-size: 13px;
  color: #ab4f03;
  cursor: pointer;
  background: none;
  border: none;
`;

export const Actions = styled.div`
  display: flex;
  flex: none;
  gap: 8px;
`;
